import type { RestaurantResponse } from '../types';

export interface OnboardingStep {
  id: string;
  title: string;
  description: string;
  icon: React.ElementType;
  isRequired: boolean;
  checkComplete: (r: RestaurantResponse | undefined) => boolean;
}

/**
 * Get the index of the first incomplete onboarding step.
 */
export function getFirstIncompleteStep(
  steps: OnboardingStep[],
  restaurant: RestaurantResponse | undefined
): number {
  for (let i = 0; i < steps.length; i++) {
    if (!steps[i].checkComplete(restaurant)) {
      return i;
    }
  }
  return -1; // All complete
}

/**
 * Check if all required onboarding steps are complete.
 */
export function isOnboardingComplete(
  steps: OnboardingStep[],
  restaurant: RestaurantResponse | undefined
): boolean {
  const requiredSteps = steps.filter((s) => s.isRequired);
  return requiredSteps.every((step) => step.checkComplete(restaurant));
}

